import Vue from 'vue'
import store from '../store'
import i18n from 'vuex-i18n'
import en from './en.js'
import es from './es.js'
import pt from './pt.js'

Vue.use(i18n.plugin, store)

Vue.i18n.add('es', es)
Vue.i18n.add('en', en)
Vue.i18n.add('pt', pt)

Vue.i18n.set('es')
Vue.i18n.fallback('en')

export default Vue.i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js